var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frbox"},[_c('froala',{attrs:{"onManualControllerReady":_vm.initialize,"config":_vm.config},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }